/*
|-------------------------------------------------------------------------------
| 引导页1
|-------------------------------------------------------------------------------
*/
import { defineStore } from '~/utils/store'
import type { IStoreState } from '~/utils/store'

/**
 * store
 */
const GuideOneStore = defineStore({
  state: () => ({
    page: '', // 后端返回的页面标识
  }),
  mutations: {
    updatePage(state, data) {
      state.page = data
    },
  },
})

export default GuideOneStore
export type IGuideOneStoreState = IStoreState<
  typeof GuideOneStore.state
>
